import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [

    {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Prospects
        // =============================================================================
        {
          path: '/',
          redirect: '/prospects'
        },
        {
          path: '/prospects',
          name: 'prospects',
          component: () => import('./views/prospects/Prosepcts.vue'),
          meta: {
            pageTitle: 'Prospects',
            rule: 'editor'
          }
        },
        {
          path: '/prospects/new',
          name: 'prospect-new',
          component: () => import('./views/prospects/actions/New.vue'),
          meta: {
            pageTitle: 'Add Prospect',
            rule: 'editor'
          }
        },
        {
          path: '/prospects/edit/:id',
          name: 'prospect-edit',
          component: () => import('./views/prospects/actions/Edit.vue'),
          meta: {
            pageTitle: 'Edit Prospect',
            rule: 'editor'
          }
        },
        {
          path: '/prospects/view/:id',
          name: 'prospect-view',
          component: () => import('./views/prospects/actions/View.vue'),
          meta: {
            pageTitle: 'View Prospect',
            rule: 'editor'
          }
        },
        // =============================================================================
        // Prospects
        // =============================================================================
        {
          path: '/vacant-properties',
          name: 'vacant-properties',
          component: () => import('./views/vacant-properties/VacantProperties.vue'),
          meta: {
            pageTitle: 'Vacant Properties',
            rule: 'editor'
          }
        },
        {
          path: '/vacant-properties/new',
          name: 'vacant-properties-new',
          component: () => import('./views/vacant-properties/actions/New.vue'),
          meta: {
            pageTitle: 'Add Vacant Property',
            rule: 'editor'
          }
        },
        {
          path: '/vacant-properties/edit/:id',
          name: 'vacant-properties-edit',
          component: () => import('./views/vacant-properties/actions/Edit.vue'),
          meta: {
            pageTitle: 'Edit Vacant Property',
            rule: 'editor'
          }
        },
        {
          path: '/vacant-properties/view/:id',
          name: 'vacant-properties-view',
          component: () => import('./views/vacant-properties/actions/View.vue'),
          meta: {
            pageTitle: 'View Vacant Property',
            rule: 'editor'
          }
        }
      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================   
        {
          path: '/home',
          name: 'home',
          component: () => import('@/views/pages/Home.vue'),
          meta: {
            rule: 'editor'
          }
        }, 
        {
          path: '/property-management',
          name: 'property-management',
          component: () => import('@/views/pages/PropertyManagement.vue'),
          meta: {
            rule: 'editor'
          }
        },   
        {
          path: '/tenant-resources',
          name: 'tenant-resources',
          component: () => import('@/views/pages/Tenants.vue'),
          meta: {
            rule: 'editor'
          }
        },    
        {
          path: '/about-us',
          name: 'about-us',
          component: () => import('@/views/pages/About.vue'),
          meta: {
            rule: 'editor'
          }
        },      
        {
          path: '/testimonials',
          name: 'testimonials',
          component: () => import('@/views/pages/Testimonials.vue'),
          meta: {
            rule: 'editor'
          }
        },       
        {
          path: '/contact-us',
          name: 'contact-us',
          component: () => import('@/views/pages/Contact.vue'),
          meta: {
            rule: 'editor'
          }
        },    
        {
          path: '/apply-for-rental',
          name: 'apply-for-rental',
          component: () => import('@/views/pages/apply-for-rental/ApplyForRental.vue'),
          meta: {
            rule: 'editor'
          }
        },     
        {
          path: '/home-for-rent/:id',
          name: 'home-for-rent',
          component: () => import('@/views/pages/home-for-rent/HomeForRent.vue'),
          meta: {
            rule: 'editor'
          }
        },      
        {
          path: '/home-for-rent/3447',
          name: 'home-for-rent-3447',
          component: () => import('@/views/pages/home-for-rent/HomeForRent2.vue'),
          meta: {
            rule: 'editor'
          }
        },        
        {
          path: '/home-for-rent/2725',
          name: 'home-for-rent-2725',
          component: () => import('@/views/pages/home-for-rent/HomeForRent3.vue'),
          meta: {
            rule: 'editor'
          }
        },         
        {
          path: '/home-for-rent/3822',
          name: 'home-for-rent-3822',
          component: () => import('@/views/pages/home-for-rent/HomeForRent4.vue'),
          meta: {
            rule: 'editor'
          }
        },           
        {
          path: '/find-a-rental',
          name: 'find-a-rental',
          component: () => import('@/views/pages/find-a-rental/FindARental.vue'),
          meta: {
            rule: 'editor'
          }
        },     
        {
          path: '/pages/login',
          name: 'page-login',
          component: () => import('@/views/pages/login/Login.vue'),
          meta: {
            rule: 'editor'
          }
        }
      ]
    }
  ]

})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})


export default router